export const selectTraceId = (state: any) => state.upload.traceId